import { c as _c } from "react/compiler-runtime";
import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import { UserAvatar } from '@src/components/sco/Account/UserAvatar';
import { FounderAdminInsights } from '@src/components/sco/Advisors/layout/FounderAdminInsights';
import { SpecialtyTag } from '@src/components/sco/Advisors/shared/SpecialtyTag';
import { founderDisplayName, founderMemberProfileHref, founderSubtitle } from '@src/components/sco/Advisors/utils/mapFounderEngagements';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ScoAdvisorEngagement } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
export const FounderMiniProfile = t0 => {
  const $ = _c(44);
  const {
    engagement
  } = t0;
  const {
    currentUser
  } = useCurrentUser();
  const founderUser = engagement.founderUser;
  const founderUserId = founderUser?.userId || engagement.founderUserId;
  let t1;
  if ($[0] !== engagement) {
    t1 = founderMemberProfileHref(engagement);
    $[0] = engagement;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const profileHref = t1;
  const categoryTitle = engagement.category?.title || "Advising";
  const bio = founderUser?.shortBio || founderUser?.title || engagement.whyText || "Founder on your advisory roster.";
  const showAdminInsights = !!currentUser?.isAdmin && !!founderUserId;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      size: "2xl"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = founderUser || undefined;
  const t4 = founderUserId || undefined;
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = <UserAvatar avatarProps={t2} user={t3} userId={t4} />;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== engagement) {
    t6 = founderDisplayName(engagement);
    $[6] = engagement;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <Text fontSize="lg" fontWeight="semibold" lineHeight="short">{t6}</Text>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== categoryTitle) {
    t8 = <SpecialtyTag colorPalette="orange" label={categoryTitle} />;
    $[10] = categoryTitle;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== engagement) {
    t9 = founderSubtitle(engagement);
    $[12] = engagement;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <Text color="colorPalette.fg/60" fontSize="xs">{t9}</Text>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t7 || $[18] !== t8) {
    t11 = <VStack gap={1}>{t7}{t8}{t10}</VStack>;
    $[16] = t10;
    $[17] = t7;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t5) {
    t12 = <VStack align="center" gap={2} textAlign="center">{t5}{t11}</VStack>;
    $[20] = t11;
    $[21] = t5;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== bio) {
    t13 = <Text color="colorPalette.fg/70" fontSize="sm" lineClamp={5} textAlign="center">{bio}</Text>;
    $[23] = bio;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== bio || $[26] !== engagement.whyText) {
    t14 = engagement.whyText && engagement.whyText !== bio && <VStack align="stretch" bg="colorPalette.bg.muted" borderRadius="md" gap={1} padding={3} width="full"><Text color="colorPalette.fg/50" textStyle="labelXs">Why they need you</Text><Text fontSize="sm">{engagement.whyText}</Text></VStack>;
    $[25] = bio;
    $[26] = engagement.whyText;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const t15 = engagement.status?.title || engagement.statusKey || "Active";
  let t16;
  if ($[28] !== t15) {
    t16 = <HStack border="1px solid" borderColor="colorPalette.border/40" borderRadius="lg" justify="center" paddingY={2} width="full"><Text color="colorPalette.fg/60" fontSize="xs">{t15} engagement</Text></HStack>;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== founderUserId || $[31] !== showAdminInsights) {
    t17 = showAdminInsights && founderUserId ? <FounderAdminInsights founderUserId={founderUserId} /> : null;
    $[30] = founderUserId;
    $[31] = showAdminInsights;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== profileHref) {
    t18 = profileHref ? <Button asChild={true} size="sm" variant="outline" width="full"><NextLink href={profileHref}>View profile</NextLink></Button> : null;
    $[33] = profileHref;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t18) {
    t19 = <VStack align="stretch" gap={2}>{t18}</VStack>;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t12 || $[38] !== t13 || $[39] !== t14 || $[40] !== t16 || $[41] !== t17 || $[42] !== t19) {
    t20 = <VStack align="stretch" gap={4} width="full">{t12}{t13}{t14}{t16}{t17}{t19}</VStack>;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
    $[40] = t16;
    $[41] = t17;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  return t20;
};